<template>
  <b-form @submit.prevent="saveLanguage" class="w-100">
    <h2 class="pb-2" v-if="title">{{ title }}</h2>
    <p class="pb-2" v-if="description">{{ description }}</p>
    <h3 class="card-title" v-if="profile">Manage Language :</h3>

    <b-button variant="primary" @click="addLanguage" class="mb-2 ml-auto">
      <feather-icon icon="PlusCircleIcon" size="18" />
    </b-button>

    <b-row
      v-for="(l, index) in form.languages"
      :key="index"
      class="align-items-end w-100 mb-1"
    >
      <!-- Language -->
      <b-col cols="8" style="min-height: 70px">
        <label>Language</label>
        <Select v-model="l.language" filterable>
          <Option v-for="lan in languageList" :value="lan" :key="lan">
            {{ lan }}
          </Option>
        </Select>
        <small
          v-if="form.errors.has('languages.' + index + '.language')"
          class="text-danger"
        >
          This field is required
        </small>
      </b-col>

      <!-- Proficiency -->
      <b-col cols="2" style="min-height: 70px">
        <label>Proficiency Level</label>
        <Select v-model="l.proficiency_level" filterable>
          <Option
            v-for="level in proficienceyLevels"
            :value="level"
            :key="level"
          >
            {{ level }}
          </Option>
        </Select>
        <small
          v-if="form.errors.has('languages.' + index + '.proficiency_level')"
          class="text-danger"
        >
          This field is required
        </small>
      </b-col>

      <!-- Remove -->
      <b-col cols="12" lg="2" style="min-height: 50px">
        <b-button
          variant="danger"
          @click="removeLanguage(index)"
          class="w-100"
          :disabled="form.languages.length === 1"
        >
          <feather-icon icon="XCircleIcon" size="18" />
        </b-button>
      </b-col>
    </b-row>

    <!-- Footer Buttons -->
    <div class="d-flex justify-content-between">
      <div>
        <router-link to="/profile" v-if="profile">
          <b-button variant="primary">Back to profile</b-button>
        </router-link>
      </div>
      <div>
        <b-button
          variant="primary"
          type="submit"
          :disabled="form.busy"
          style="margin-right: 30px"
        >
          Save
        </b-button>
      </div>
    </div>
  </b-form>
</template>

<script>
import { BRow, BCol, BForm, BButton } from "bootstrap-vue";
import { HasError, AlertError } from "vform/src/components/bootstrap5";

export default {
  props: [
    "title",
    "nextOnboard",
    "nextTitle",
    "nextName",
    "description",
    "profile",
  ],
  data() {
    return {
      form: new Form({
        languages: [
          {
            language: null,
            proficiency_level: null,
          },
        ],
      }),
      proficienceyLevels: [1, 2, 3, 4, 5],
      languageList: [
        "English",
        "Mandarin Chinese",
        "Spanish",
        "Hindi",
        "Arabic",
        "Bengali",
        "Portuguese",
        "Russian",
        "Japanese",
        "Punjabi",
        "German",
        "Javanese",
        "Wu Chinese (Shanghainese)",
        "Malay / Indonesian",
        "Telugu",
        "Vietnamese",
        "Korean",
        "French",
        "Marathi",
        "Tamil",
        "Urdu",
        "Turkish",
        "Italian",
        "Yue Chinese (Cantonese)",
        "Thai",
        "Gujarati",
        "Jin Chinese",
        "Southern Min (Hokkien)",
        "Persian (Farsi)",
        "Polish",
        "Pashto",
        "Kannada",
        "Xiang Chinese",
        "Malayalam",
        "Sundanese",
        "Hausa",
        "Odia (Oriya)",
        "Burmese",
        "Hakka",
        "Ukrainian",
        "Bhojpuri",
        "Tagalog (Filipino)",
        "Yoruba",
        "Maithili",
        "Uzbek",
        "Sindhi",
        "Amharic",
        "Fula",
        "Romanian",
        "Oromo",
        "Igbo",
        "Azerbaijani",
        "Dutch",
        "Kurdish",
        "Serbo-Croatian",
        "Malagasy",
        "Nepali",
        "Sinhalese",
        "Khmer",
        "Cebuano",
        "Assamese",
        "Hungarian",
        "Chittagonian",
        "Somali",
        "Czech",
        "Greek",
        "Swedish",
        "Belarusian",
        "Hebrew",
        "Danish",
        "Finnish",
        "Norwegian",
        "Slovak",
        "Bulgarian",
        "Croatian",
        "Lithuanian",
        "Latvian",
        "Estonian",
        "Georgian",
        "Armenian",
        "Mongolian",
        "Albanian",
        "Bosnian",
        "Icelandic",
      ],
    };
  },
  components: {
    BRow,
    BCol,
    BForm,
    BButton,
    HasError,
    AlertError,
  },
  mounted() {
    this.showLanguage();
  },
  methods: {
    showLanguage() {
      axios
        .get("/candidate/language")
        .then((res) => {
          if (res.data.languages.length == 0) {
            this.form.languages = [
              {
                language: null,
                proficiency_level: null,
              },
            ];
          } else {
            this.form.languages = res.data.languages;
          }
        })
        .catch((e) => {
          this.e(e.response?.data?.error || "Failed to load languages");
        });
    },
    saveLanguage() {
      this.form
        .post(`/candidate/language`)
        .then((res) => {
          this.s(res.data.message);
          this.showLanguage();
        })
        .catch((e) => {
          this.e(e.response?.data?.message || "Error saving languages");
        });
    },
    addLanguage() {
      this.form.languages.push({
        language: null,
        proficiency_level: null,
      });
    },
    removeLanguage(index) {
      this.form.languages.splice(index, 1);
    },
  },
};
</script>
